import Icon from '@material-ui/icons/LocalShipping';
import List from './ShipmentList';
import Create from './ShipmentCreate';
import Show from './ShipmentShow';

export default {
    list: List,
    create: Create,
    show: Show,
    icon: Icon,
};
